import { render } from "./RequisitionOverview.vue?vue&type=template&id=5258ed9d&scoped=true&ts=true"
import script from "./RequisitionOverview.vue?vue&type=script&lang=ts"
export * from "./RequisitionOverview.vue?vue&type=script&lang=ts"

import "./RequisitionOverview.vue?vue&type=style&index=0&id=5258ed9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5258ed9d"]])

export default __exports__